<div class="account-pages mt-5 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center">
          <a href="/" class="mb-4 d-block auth-logo">
            <img src="assets/images/KASHPOS.png" alt="" class="logo logo-dark tamaños">
            <img src="assets/images/KASHPOS.png" alt=""
              class="logo logo-light tamaños">
          </a>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden background-login">
          <div class="card-body p-4" style="background-color: #000 !important;">
            <div class="text-center mt-2">
              <h5 class="greens">Restaurar Contraseña</h5>
              <p class="text-muted text-white">Recuerda que tu contraseña será la misma para ingresar a nuestro sistema.</p>
            </div>
            <div class="p-2 mt-4">
              <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" novalidate>
                
                <div class="mb-3 position-relative">
                  <label class="text-white" for="new-password">Nueva Contraseña: </label>
                  <input [type]="type2" autocomplete="new-password" class="form-control pr-5" id="new-password" 
                    formControlName="newPassword" placeholder="******" (input)="onPasswordInput()" />
                  <span class="eyeButton position-absolute" (click)="myFunctionPasswordConfirm()" style="right: 10px; top: 40px;">
                    <i [class]="type2 === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                  </span>
                </div>
                
                <div class="mb-3 position-relative">
                  <label class="text-white" for="confirm-password">Confirmar Contraseña: </label>
                  <input [type]="type3" class="form-control pr-5" id="confirm-password"
                    formControlName="confirmPassword" placeholder="******" (input)="onPasswordInput()" />
                  <span class="eyeButton position-absolute" (click)="myFunctionPasswordConfirmThre()" style="right: 10px; top: 40px;">
                    <i [class]="type3 === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                  </span>
                  <div *ngIf="signupForm.controls['confirmPassword'].errors?.mustMatch">
                    <small class="text-danger">Las contraseñas no coinciden.</small>
                  </div>
                </div>
                
                <div class="mt-3">
                  <p class="mb-0">
                    <i class="fa fa-check-circle" [ngClass]="{ checked: minCaracteres && maxCaracteres }"
                      aria-hidden="true"></i>
                    La contraseña debe tener más de 6 caracteres y menos de 16.
                  </p>
                  <p class="mb-0">
                    <i class="fa fa-check-circle" [ngClass]="{ checked: hasMayus && hasMinus }" aria-hidden="true"></i>
                    Al menos una mayúscula y minúsculas.
                  </p>
                  <p class="mb-0">
                    <i class="fa fa-check-circle" [ngClass]="{ checked: espCaracter }" aria-hidden="true"></i>
                    Un caracter no alfanumérico (ejemplo: #?!&).
                  </p>
                  <p class="mb-0">
                    <i class="fa fa-check-circle" [ngClass]="{ checked: hasNumber }" aria-hidden="true"></i>
                    Un número.
                  </p>
                </div>
                
                <div class="mt-3 text-end" style="display: flex; justify-content: end;">
                  <button type="submit" [disabled]="signupForm.invalid || loadIndicatorVisible" class="btn blueButton w-sm waves-effect waves-light"  style="margin-left: 15px; width: 40%;">
                    <dx-load-indicator *ngIf="loadIndicatorVisible" id="small-indicator" height="20" width="20"></dx-load-indicator><i *ngIf="!loadIndicatorVisible" class="fa fa-floppy-o"></i>&nbsp;&nbsp;{{buttonText}}
                  </button>
                  <!-- <button class="btn blueButton w-sm waves-effect waves-light" type="submit" [disabled]="signupForm.invalid" style="width: 40%;"><i class="fa fa-floppy-o"></i>&nbsp;&nbsp;Guardar</button> -->
                  <button class="btn cancel w-sm waves-effect waves-light" (click)="irLogin()" style="margin-left: 15px;" type="button"><i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="mt-3 text-center text-white">
          <p>Copyright 2024 © TECSA All rights reserved.</p>
        </div>

      </div>
    </div>
  </div>
</div>
